import React, { useContext } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, registerables, ChartOptions, ChartData } from 'chart.js';
import font from '../../config/Fonts';
import color from '../../config/Colors';
import { AnprMatchesDailyStats } from '../../models/AnprMatchesDailyStats';
import { formatDate } from '../../helpers/moment';
import { LanguageContext } from '../../contexts/useLanguage';
import useMedia from '../../hooks/useMedia';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatNumber } from '../../helpers/FormatCurrency';
ChartJS.register(...registerables);

type Props = {
    anprMatchesDailyStats: AnprMatchesDailyStats[];
};

export default function BarChartEVDailyVisits(props: Props) {
    const { isMobileSM, isMediumMD } = useMedia();
    const { t } = useContext(LanguageContext);

    const data: ChartData<'bar', number[], string> = {
        labels:
            props.anprMatchesDailyStats &&
            props.anprMatchesDailyStats.map((item) => formatDate.getLocalDay2(item.inDate)),
        datasets: [
            {
                label: 'EV',
                data: props.anprMatchesDailyStats && props.anprMatchesDailyStats.map((item) => item.qtyTotalOfEV!),
                backgroundColor: '#A7D930',
            },
        ],
    };

    const options: ChartOptions<'bar'> = {
        responsive: true,
        // set height not crash
        maintainAspectRatio: false,
        plugins: {
            //note
            legend: {
                display: false,
                position: 'bottom' as const,
                align: 'center',
                //set note label font
                labels: {
                    font: {
                        family: font,
                        size: isMobileSM ? 12 : isMediumMD ? 14 : 16,
                    },
                    padding: isMobileSM ? 10 : 20,
                    boxWidth: 5,
                    boxHeight: 5,
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },

            // Top Label
            datalabels: {
                display: true,
                color: 'black',
                anchor: 'end',
                align: 'top',
                font: {
                    family: font,
                    size: isMobileSM || props.anprMatchesDailyStats.length > 10 ? 9 : 11,
                },

                formatter(value, context) {
                    return formatNumber.format(value);
                },
            },

            tooltip: {
                enabled: true,
                callbacks: {
                    label(tooltipItems: any) {
                        return ` ${tooltipItems.dataset.label}: ${tooltipItems.formattedValue}`;
                    },
                },
            },
        },
        layout: {
            padding: {
                top: 20,
            },
        },
        //setting grid
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        family: font,
                    },
                },
                stacked: true,
            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        family: font,
                    },
                    //y step
                    stepSize: 1000,
                },

                //y label start at 0
                beginAtZero: true,
                min: 0,
                stacked: true,
            },
        },
    };

    return <Bar options={options} data={data} plugins={[ChartDataLabels]} />;
}
